<template>
    <div id="map" class="page m-topicLibrary">

        <div class="map-main">
            <el-form class="page-query" :model="formSearch" :inline="true" size="mini">
                <el-form-item :label="$t('topic.questionDesc')">
                    <el-input v-model="formSearch.title" :placeholder="$t('tip.titleDesc')"
                              :class="{'big-input': $i18n.locale==='en'}"
                              @keyup.enter.native="query(1)"
                              clearable></el-input>
                </el-form-item>
                <el-form-item :label="$t('c.problemNo')">
                    <el-input v-model="formSearch.number" :placeholder="$t('tip.problemNo')"
                              @keyup.enter.native="query(1)" clearable></el-input>
                </el-form-item>

                <select-multiple :nameArrays="selectNames"
                                 @getForLevelVal="getForLevelVal"
                                 @getDifficultyVal="getDifficultyVal"
                                 @getTopicTypeVal="getTopicTypeVal"
                >
                </select-multiple>

                <select-multi-knowledge @knowledgeChange="knowledgeChange"></select-multi-knowledge>

                <el-form-item :label="$t('c.creator')">
                    <el-input v-model="formSearch.creatorName" :placeholder="$t('tip.creator')" clearable></el-input>
                </el-form-item>
                <el-form-item :label="$t('c.creationTime')">
                    <el-date-picker
                        v-model="formSearch.create_time_after"
                        type="date"
                        :placeholder="$t('tip.startTime')"
                        :picker-options="pickerOptions1"
                        value-format="yyyy-MM-dd">
                    </el-date-picker>
                    <span> {{$t('c.to')}} </span>
                    <el-date-picker
                        v-model="formSearch.create_time_before"
                        type="date"
                        :placeholder="$t('tip.endTime')"
                        :picker-options="pickerOptions2"
                        value-format="yyyy-MM-dd">
                    </el-date-picker>
                </el-form-item>
                <el-form-item>
                    <el-button type="primary" @click="query(1)" round>{{$t('c.query')}}</el-button>
                </el-form-item>
            </el-form>
            <div class="page-table">
                <div class="page-operate">
                    <!--<el-switch-->
                    <!--class="switch-style"-->
                    <!--v-model="switchStyle"-->
                    <!--@change="styleChange"-->
                    <!--active-color="#13ce66"-->
                    <!--inactive-color="#ff4949"-->
                    <!--:active-text="$t('topic.detailView')"-->
                    <!--:inactive-text="$t('topic.listView')">-->
                    <!--</el-switch>-->
                    <el-button-group v-if="listData.length>0">
                        <el-tooltip class="item" effect="dark" :content="$t('topic.papersTimesSort')" placement="top-start" :hide-after="1000">
                            <el-button size="small" @click="orderChange(1)" :class="[this.sortName=='usageCount' && this.order=='Asc' ? 'btn-active': 'btn-not-active']">
                                <i class="nucfont inuc-compose-times"></i>
                            </el-button>
                        </el-tooltip>
                        <el-tooltip class="item" effect="dark" :content="$t('topic.rightRateSort')" placement="top-start"
                                    :hide-after="1000">
                            <el-button size="small" @click="orderChange(2)" :class="[this.sortName=='accuracy' && this.order=='Asc' ? 'btn-active': 'btn-not-active']">
                                <i class="nucfont inuc-right-rate"></i>
                            </el-button>
                        </el-tooltip>
                        <el-tooltip class="item" effect="dark" :content="$t('topic.default')" placement="top-start"
                                    :hide-after="1000">
                            <el-button size="small" @click="orderChange(3)" :class="[this.sortName=='' && this.order=='Asc' ? 'btn-active': 'btn-not-active']">
                                <i class="nucfont inuc-default-sort"></i>
                            </el-button>
                        </el-tooltip>
                    </el-button-group>
                    <div style="float: right">
                        <el-radio-group v-model="radio3" size="small" @change="styleChange">
                            <el-radio-button :label="$t('topic.detailView')"></el-radio-button>
                            <el-radio-button :label="$t('topic.listView')"></el-radio-button>
                        </el-radio-group>
                    </div>
                </div>
                <div class="map-list-box">
                    <div class="map-list" :class="{'map-list-table':!switchStyle}" id="file-list">
                        <template v-if="switchStyle">
                            <ul class="clearfix" v-viewer="{movable: false}">
                                <li class="map-list-outer" v-for="(item,index) in listData" :key="item.id">
                                    <div class="topic-info">
                                        <div>
                                            <p>{{index+1}}、</p>
                                            <p>【<span>{{item.number}}</span>】</p>
                                            <p>( <span>{{item.typeName}}</span>, {{$t('topic.papersAssembled')}}: <span>{{item.usageCount}}</span> )</p>
                                            <p>{{$t('c.knowledgePoint')}}: <span>{{item.knowledgeName}}</span></p>
                                            <p>{{$t('c.operatorLevel')}}: <span>{{item.forLevelName}}</span></p>
                                            <p>{{$t('c.difficulty')}}: <span>{{item.difficultyName}}</span></p>
                                            <p>{{$t('topic.rightRate')}}: <span>{{item.accuracy!=-1?(Math.round(item.accuracy * 10000) / 100 + '%'):'-'}}</span></p>
                                            <!--<p>{{$t('c.problemNo')}}: <span>{{item.number}}</span></p>-->
                                        </div>
                                        <div>
                                            <span class="topic-author">{{$t('c.creator')}}: {{item.creatorName}}</span>
                                        </div>
                                    </div>
                                    <div class="topic-main">
                                        <div class="theory-topic" v-if="item.type < 4">
                                            <div v-html="item.titleRT" class="theory-topic-title"></div>
                                            <ul class="single-topic" v-if="item.type ==1">
                                                <li class="topic-item" v-for="sItem in item.options" :key="sItem.id">
                                                    <div class="choice-option"><i class="nucfont inuc-radio-o" :class="{'inuc-radio-active': sItem.isRight}"></i> {{sItem.tagName}}</div>
                                                    <div class="choice-html" v-html="sItem.titleRT"></div>
                                                </li>
                                            </ul>
                                            <ul class="single-topic" v-if="item.type ==2">
                                                <li class="topic-item" v-for="sItem in item.options" :key="sItem.id">
                                                    <div class="choice-option"><i class="nucfont inuc-checkbox" :class="{'inuc-checkbox-checked': sItem.isRight}"></i> {{sItem.tagName}}</div>
                                                    <div class="choice-html" v-html="sItem.titleRT"></div>
                                                </li>
                                            </ul>
                                            <ul class="choice-topic" v-if="item.type ==3">
                                                <li class="topic-item">
                                                    <div class="choice-option"><i class="nucfont inuc-radio-o" :class="{'inuc-radio-active': item.options.find(v => v.tag===1).isRight}"></i></div>
                                                    <div>{{$t('c.right')}}</div>
                                                </li>
                                                <li class="topic-item">
                                                    <div class="choice-option"><i class="nucfont inuc-radio-o" :class="{'inuc-radio-active': item.options.find(v => v.tag===0).isRight}"></i></div>
                                                    <div>{{$t('c.wrong')}}</div>
                                                </li>
                                            </ul>
                                        </div>

                                        <div class="image-topic" v-if="item.type > 4">
                                                <el-carousel
                                                    indicator-position="outside"
                                                    :autoplay="false"
                                                    height="160px"
                                                    trigger="click"
                                                    :arrow="item.thumbnails.length>1? 'always':'never'"
                                                >
                                                    <el-carousel-item v-for="(pItem,pIndex) in item.thumbnails" :key="pIndex">
                                                        <div class="carousel-wrap">
                                                            <img :src="pItem.url" alt="">
                                                        </div>
                                                    </el-carousel-item>
                                                </el-carousel>
                                        </div>
                                        <div class="image-topic match"  v-if="item.type == 4">
                                            <div v-html="item.titleRT" class="match-topic-title"></div>
                                            <div class="image-wrap">
                                                <div class="image">
                                                    <img :src="item.picViewUrl ? item.picViewUrl : ''" alt="">
                                                </div>
                                                <ul class="option-wrap">
                                                    <li v-for="item in item.rectangleOptions" :key="'m'+item.id" class="option-item"> {{item.tagName + '. '+item.answerName}}</li>
                                                </ul>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="topic-tips">
                                        <div class="topic-tips-title">
                                            <div class="topic-opr">
                                                <a href="#" class="j-ans-img" :class="{'active':item.answerShow}" data-class-name="j-answer" @click="displayAnswer(index)">{{$t('topic.answerAnalysis')}}</a>
                                                <a href="#" class="j-des-img" :class="{'active':item.type > 4 && item.imageShow}" data-class-name="j-describe" @click="displayImage(index)" v-if="item.type > 4">{{$t('topic.imageDesc')}}</a>
                                            </div>
                                            <div><span>{{$t('c.creationTime')}} : {{item.createTime}}</span></div>
                                        </div>
                                        <div class="j-img j-answer" v-if="item.answerShow" v-html="item.analysisRT || $t('c.none')"></div>
                                        <div class="j-img j-describe" v-if="item.type > 4 && item.imageShow" >{{$t('c.none')}}</div>
                                    </div>
                                </li>
                            </ul>
                            <span v-show="!pagTotal" class="emptyBox">
                                {{$t('c.noData')}}
                        </span>
                        </template>
                        <template v-else>
                            <ul class="map-table-tile">
                                <li class="topic-num">{{$t('c.problemNo')}}</li>
                                <li class="topic-type">{{$t('paper.questionType')}}</li>
                                <li class="topic-des">{{$t('topic.questionDesc')}}</li>
                                <!--<li class="topic-img">{{$t('c.image')}}</li>-->
                                <li class="topic-kp">{{$t('c.knowledgePoint')}}</li>
                                <li class="topic-pro">{{$t('c.operatorLevel')}}</li>
                                <li class="topic-pro">{{$t('c.difficulty')}}</li>
                                <li class="topic-pro">{{$t('topic.papersAssembleTimes')}}</li>
                                <li class="topic-pro">{{$t('topic.rightRate')}}</li>
                                <li class="topic-pro">{{$t('c.creator')}}</li>
                                <li class="topic-time">{{$t('c.creationTime')}}</li>
                            </ul>
                            <div>
                                <transition-group tag="ul" class="clearfix" enter-active-class="animated fadeIn"
                                                  leave-active-class="animated fadeOut" v-viewer="{movable: false}">

                                    <li class="map-table-item" v-for="item in listData" :key="item.id">
                                        <div class="topic-num">
                                            <a class="map-item-name">{{item.number}}</a>
                                        </div>
                                        <div class="topic-type">
                                            <type-tag type="topicType" :id="item.type" :name="item.typeName"></type-tag>
                                        </div>
                                        <div class="topic-img" v-if="item.type==5 || item.type==6">
                                            <img :src="item.thumbnails ? item.thumbnails[0].url:'-'" >
                                        </div>
                                        <div class="topic-des" v-html="item.titleRT" :title="item.title" v-else>
                                        </div>
                                        <div class="topic-kp">
                                            {{item.knowledgeName}}
                                        </div>
                                        <div class="topic-pro">
                                            {{item.forLevelName}}
                                        </div>
                                        <div class="topic-pro">
                                            {{item.difficultyName}}
                                        </div>
                                        <div class="topic-pro">
                                            {{item.usageCount}}
                                        </div>
                                        <div class="topic-pro">
                                            <span class="accuracy-bg" :class="accBg(item.accuracy)">{{item.accuracy!=-1?(Math.round(item.accuracy * 10000) / 100 + '%'):'-'}}</span>
                                        </div>
                                        <div class="topic-pro">
                                            {{item.creatorName}}
                                        </div>
                                        <div class="topic-time">
                                            {{item.createTime}}
                                        </div>
                                    </li>

                                </transition-group>
                            </div>
                            <span v-show="!pagTotal" class="emptyBox">
                                 {{$t('c.noData')}}
                             </span>
                        </template>

                    </div>

                </div>
                <div class="pagination-bar">
                    <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
                                   :current-page="currentPage" :page-sizes="[20, 50, 100, 300, 500]"
                                   :page-size="pageSize"
                                   layout="prev, pager, next, jumper, sizes,total " :total="pagTotal">
                    </el-pagination>
                </div>
            </div>
            <transition enter-active-class="animated zoomInRight"
                        leave-active-class="animated zoomOutUp">
                <router-view @updateData="query"></router-view>
            </transition>
        </div>
    </div>
</template>

<script>
    import selectMultiple from '@/components/Selectmultiple.vue'
    import selectMultiKnowledge from '@/components/SelectMultiKnowledge';
    import api from '@/api';

    export default {
        name: 'Storage',
        data () {
            return {
                radio3:this.$t('topic.detailView'),
                listData: [],
                selectNames: [
                    {key: "forLevel"},{key: "difficulty"}, {key: "topicType"},
                ],
                formSearch:{
                    title:'',
                    number:'',
                    types: [],
                    forLevels: [],
                    difficulties: [],
                    knowledges:[0],
                    creatorName:'',
                    create_time_after:'',
                    create_time_before:''
                },
                pagTotal: 0,
                pageSize:20,
                currentPage: 1,
                isDeleteShow: false,
                switchStyle: true,
                selectTopics:[],
                checkAll: false,
                isIndeterminate: true,
                isAuto:false,
                sortName:'',
                order:'',
                useOrder:'Desc',
                accOrder:'Desc',
                defaultOrder:'Desc',
            }
        },
        computed: {
            pickerOptions1() {
                let that = this;
                return {
                    disabledDate(time) {
                        if (!that.formSearch.create_time_before) return false;
                        return time.getTime() > new Date(that.formSearch.create_time_before).getTime()
                    },
                }
            },
            pickerOptions2() {
                let that = this;
                return {
                    disabledDate(time) {
                        if (!that.formSearch.create_time_after) return false;
                        return time.getTime() < new Date(that.formSearch.create_time_after).getTime()
                    },
                }
            },
        },
        created() {
            this.query();
        },
        methods: {
            query(type) {
                if(type==1){
                    this.currentPage=1;
                }

                let queryData = {
                    number: this.formSearch.number,
                    title: this.formSearch.title,
                    create_time_after:this.formSearch.create_time_after,
                    create_time_before:this.formSearch.create_time_before,
                    pageNo: this.currentPage,
                    limit: this.pageSize,
                    sortName:this.sortName,
                    order:this.order,
                    creatorName:this.formSearch.creatorName,
                };
                if (!(this.formSearch.types.includes(0))) {
                    Object.assign(queryData, {
                        types: this.formSearch.types,
                    })
                }
                if (!(this.formSearch.forLevels.includes(0))) {
                    Object.assign(queryData, {
                        forLevels: this.formSearch.forLevels,
                    })
                }
                if (!(this.formSearch.difficulties.includes(0))) {
                    Object.assign(queryData, {
                        difficulties: this.formSearch.difficulties,
                    })
                }
                if (!(this.formSearch.knowledges.includes(0))) {
                    Object.assign(queryData, {
                        knowledges: this.formSearch.knowledges,
                    })
                }

                api.getTopicList(queryData).then(res => {
                    res.package.forEach(v => {
                        if (v.accuracy == null) {
                            v.accuracy = -1
                        }
                    });
                    this.listData = res.package;
                    this.listData.forEach(item=>{
                        item.answerShow=true;
                        item.imageShow=false;
                    })
                    this.pagTotal = res.total;
                })
            },
            orderChange(orderType){
                switch (orderType){
                    case 1:
                        this.sortName='usageCount';
                        if(this.useOrder=='Desc'){
                            this.useOrder='Asc'
                        }else {
                            this.useOrder='Desc'
                        }
                        this.order=this.useOrder
                        break;
                    case 2:
                        this.sortName='accuracy';
                        if(this.accOrder=='Desc'){
                            this.accOrder='Asc'
                        }else{
                            this.accOrder='Desc'
                        }
                        this.order=this.accOrder
                        break;
                    case 3:
                        this.sortName='';
                        if(this.defaultOrder=='Desc'){
                            this.defaultOrder='Asc'
                        }else{
                            this.defaultOrder='Desc'
                        }
                        this.order=this.defaultOrder
                        break;
                }
                this.query();
            },

            getTopicTypeVal(data){
                this.formSearch.types = data;
            },
            getForLevelVal(data){
                this.formSearch.forLevels = data;
            },
            getDifficultyVal(data) {
                this.formSearch.difficulties = data;
            },
            knowledgeChange(data) {
                this.formSearch.knowledges = data;
            },
            styleChange(val){
                if(val==this.$t('topic.detailView')){
                    this.switchStyle=true;
                }else{
                    this.switchStyle=false
                }
            },
            selectTopicChange(value) {
                this.isDeleteShow = this.selectTopics.length > 0;
                let checkedCount = value.length;
                this.checkAll = checkedCount === this.listData.length;
                this.isIndeterminate = checkedCount > 0 && checkedCount < this.listData.length;
            },
            handleCurrentChange(val) {
                this.currentPage = val;
                this.query();
            },
            handleSizeChange(val) {
                this.pageSize = val;
                this.query();
            },
            success(msg) {
                this.$message({
                    message: msg,
                    type: 'success'
                })
            },
            displayImage(index){
                if(this.listData[index].answerShow){
                    this.listData[index].answerShow = false;
                }
                this.listData[index].imageShow = !this.listData[index].imageShow
                this.$set(this.listData, index, this.listData[index])
            },
            displayAnswer(index){
                if(this.listData[index].imageShow){
                    this.listData[index].imageShow = false;
                }
                this.listData[index].answerShow = !this.listData[index].answerShow
                this.$set(this.listData, index, this.listData[index])
            },
            accBg(value){
                let accbg;
                if(value==null){
                    accbg='acc-bg-null'
                }else if(value*100<10){
                    accbg='acc-bg-single'
                }
                return accbg
            }
        },
        components: {
            selectMultiple, selectMultiKnowledge
        }
    }
</script>

<style lang="scss" scoped>
    @import '../../style/const';

    @include scrollbar();
    .page-operate {
        height: 32px;
        line-height: 32px;
        margin-bottom: 15px;

        .switch-style {
            float: right;
            margin-top: 5px;
            margin-left: 20px;
        }
    }

    .map-list-box {
        position: relative;
        /*display: flex;*/
        /*flex-direction: column;*/
        flex: 1;
        margin-top: 8px;
        min-height: 82%;
        .map-list {
            flex: 1;
            overflow-y: auto;
            /*min-height: calc(49vh - 10px);*/
            .emptyBox{
                position: absolute;
                left: 50%;
                top: 50%;
                transform: translate(-50%, -50%);
                color: #909399;
            }
            .right-menu {
                position: fixed;
                background: #fff;
                border: solid 1px rgba(0, 0, 0, .2);
                border-radius: 3px;
                z-index: 999;
                display: none;
            }
            .right-menu a {
                margin: 0 auto;
                width: 160px;
                height: 28px;
                line-height: 28px;
                text-align: center;
                display: block;
                color: #1a1a1a;
            }
            .right-menu a:hover {
                background: #eee;
                color: #fff;
            }

            .right-menu {
                border: 1px solid #eee;
                box-shadow: 0 0.5em 1em 0 rgba(0, 0, 0, .1);
                border-radius: 1px;
            }

            .right-menu a {
                padding: 2px;
            }
            .right-menu a:hover {
                background: #42b983;
            }
        }

        .map-list-outer {
            position: relative;
            margin-bottom: 24px;
            border: 1px solid #ddd;
            border-radius: 2px;
            background-color: #f4f3f8;
            color: #666;
            font-size: 14px;
            .topic-info {
                display: flex;
                justify-content: space-between;
                align-items: center;
                padding: 10px 28px 10px 10px;
                height: auto;
                flex-wrap: wrap;
                line-height: 1.8;
                div{
                    display: flex;
                    flex-wrap: wrap;
                    .topic-author{
                        color: #9699a2;
                    }
                    p{
                        margin-right: 15px;
                        > span {
                            color: #ff0451;
                        }
                    }
                }
            }
            .topic-main {
                padding: 10px 28px 2px 28px;
                background: #fff;
                .theory-topic{
                    padding: 5px 30px;
                    .theory-topic-title{
                        padding-bottom: 10px;
                        word-break: break-all;
                    }
                    .topic-item{
                        display: flex;
                        padding-bottom: 5px;
                        word-break: break-all;
                        .choice-option{
                            min-width: 38px;
                            > i{
                                font-size: 14px;
                                &.inuc-checkbox-checked, &.inuc-radio-active {
                                    color: #ff4081;
                                }
                            }
                        }
                    }
                    .choice-topic .choice-option {
                        min-width: 25px;
                    }
                }
                .image-topic{
                    text-align: left;
                    &.match{
                        margin-bottom: 10px;
                        .match-topic-title{
                            padding-left: 30px;
                            padding-bottom: 10px;
                        }
                        .image-wrap{
                            display: flex;
                            height: 160px;
                            padding-left: 30px;
                            .image{
                                width: 250px;
                                height: 100%;
                                padding: 5px;
                                border: 1px solid #ccc;
                                box-shadow: 0 2px 4px -2px #999;
                                cursor: pointer;
                                text-align: center;
                                img{
                                    max-width: 100%;
                                    max-height: 100%;
                                }
                                &:hover{
                                    border: 1px solid #00bcd4;
                                }
                            }
                            .option-wrap{
                                margin-top: 10px;
                                margin-left: 20px;
                                .option-item{
                                    margin-bottom: 12px;
                                }
                            }
                        }
                    }
                    .topic-img{
                        display: flex;
                        justify-content: space-between;
                        align-items: center;
                        height: 200px;
                        padding: 20px 0;
                        .img-wrap{
                            flex: 1;
                            height: 100%;
                            overflow: hidden;
                            ul {
                                min-width: 200%;
                                height: 100%;
                                padding: 5px 0;
                                transition: all .3s;
                                > li {
                                    float: left;
                                    display: flex;
                                    justify-content: center;
                                    align-items: center;
                                    width: 250px;
                                    height: 100%;
                                    margin-right: 20px;
                                    padding: 10px;
                                    border: 1px solid #ccc;
                                    box-shadow: 0 2px 4px -2px #999;
                                    cursor: pointer;
                                    &:last-child{
                                        margin-right: 0px;
                                    }
                                    &:hover{
                                        border-color: #0cc;
                                    }
                                    img {
                                        max-width: 100%;
                                        max-height: 100%;
                                    }
                                }
                            }
                        }

                    }
                }
            }
            .topic-tips {
                padding: 0 28px;
                background: #f4f3f8;
                .topic-tips-title{
                    display: flex;
                    justify-content: space-between;
                    align-items: center;
                    padding: 10px 0;
                    a{
                        padding: 3px 8px;
                        margin-right: 5px;
                        background-color: #2e7faa;
                        color: #fff;
                        &.active{
                            background-color: #dee8f1;
                            color: #2e7faa;
                        }
                    }
                    span {
                        padding-right: 5px;
                        color: #999;
                    }
                }
                .j-img{
                    padding: 10px 0 10px 2px;
                    border-top: 1px dashed #ccc;
                }
            }
        }

    }
    $map-bg: #f1f5fa;
    $map-select-border: #90c3fd;

    .map-item {
        position: relative;
        width: 122px;
        height: 128px;
        border: 1px solid transparent;
        z-index: 1;
        cursor: pointer;

        .folder {
            display: flex;
            justify-content: center;
            align-items: center;
            width: 84px;
            height: 84px;
            margin: 9px auto 0;
            background: url(../../assets/images/map/folder.png) center no-repeat;
            background-size: cover;

            .map-item-img {
                max-width: 70%;
                max-height: 55%;
                margin-top: 10px;
            }
        }

        &-name {
            margin: 6px 5px;
            font-size: 14px;
            text-align: center;
            @include no-wrap();
        }

        .el-checkbox {
            position: absolute;
            display: none;
            top: 8px;
            right: 0;

            &.is-checked {
                display: block;

                + .checked-bg {
                    position: absolute;
                    top: 0;
                    bottom: 0;
                    left: 0;
                    right: 0;
                    border: 1px solid $map-select-border;
                    background-color: $map-bg;
                    border-radius: 5px;
                    z-index: -1;
                }
            }
        }

        &:hover {
            border-color: $map-bg;
            background-color: $map-bg;
            border-radius: 5px;

            .el-checkbox {
                display: block;
            }
        }
    }
    .btn-active{
        background-color: #22B9FF;
        color:#fff;
    }
    .btn-not-active{
        background-color: #fff;
        color:#606266;
        border-color: #dcdfe6;
        &:hover{
            color: #22B9FF;
            border-color: #bdeaff;
            background-color: #e9f8ff;
        }
    }
    // 表格形式
    .map-list-table {
        overflow: hidden !important;

        .map-table-tile {
            //margin-top: -10px;
            height: 52px;
            line-height: 52px;
            border-bottom: 1px solid #f2f6fd;
            background-color: #f4f3f8;

            > li {
                font-size: 16px;
                color: #252525;
                font-weight: bold;
                text-align: center;
                overflow: hidden;
                text-overflow: ellipsis;
                white-space: nowrap;
            }

        }

        .topic-num {
            display: inline-block;
            width: 7%;
        }
        .topic-type {
            display: inline-block;
            width: 7%;
        }
        .topic-img{
            display: inline-block;
            width: 27%;
            > img{
                max-height: 100%;
                cursor: pointer;
            }
        }
        .topic-des {
            display: inline-block;
            width: 27%;
        }
        .topic-pro {
            display: inline-block;
            width: 6%;
        }
        .topic-kp {
            display: inline-block;
            width: 14%;
        }
        .topic-time {
            display: inline-block;
            width: 10%;
        }
        .map-table-item {

            border-bottom: 1px solid #f2f6fd;
            color: #595959;
            &:hover {
                background-color: #f6faff;
            }
            > div{
                font-size: 14px;
                text-align: center;
                box-sizing: border-box;
                overflow: hidden;
                text-overflow: ellipsis;
                white-space: nowrap;
                height: 58px;
                line-height: 58px;
                &.topic-img{
                    height: 68px;
                    line-height: 68px;
                }
            }
            .topic-pro{
                .accuracy-bg{
                    display: inline-block;
                    width: 65px;
                    height: 24px;
                    line-height: 24px;
                    border-radius: 12px;
                    color: #fff;
                    background-color: #34bfa3;
                }
            }
        }

    }

    .select-all{
        padding: 3px 20px;
    }
    .el-carousel__item {
        text-align: center;
        vertical-align: middle;
        .carousel-wrap{
            display: flex;
            justify-content: center;
            align-items: center;
            width: 250px;
            height: 100%;
            padding: 5px;
            border: 1px solid #ccc;
            box-shadow: 0 2px 4px -2px #999;
            cursor: pointer;
            margin: 0 auto;
            img{
                max-width: 100%;
                max-height: 100%;
            }
            &:hover{
                border: 1px solid #00bcd4;
            }
        }
    }

    .big-input {
        width: 220px;
    }
</style>
<style lang="scss">
    .m-topicLibrary{
        .el-radio-button--small .el-radio-button__inner{
            font-size: 14px;
        }
        .page-table{
            display: block;
            margin-bottom: 10px;
        }

    }
    /*.el-carousel__container{*/
        /*height: 160px;*/
    /*}*/
</style>
